<template>
  <div class="animated fadeIn">
    <div v-if="loading">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-if="!loading">
      <div class="w-full">
        <div class="customer-tab">
          <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
            <vs-tabs
              v-model="activeTab"
              alignment="fixed"
              class="tab-action-btn-fill-conatiner"
            >
              <vs-tab :label="$t('billManagement.label.BillHistory')">
                <vx-card>
                  <vs-table
                    :max-items="paginationItems[1]"
                    pagination
                    :data="billHistoryList || []"
                    :description="false"
                    :description-items="paginationItems"
                    description-title="Registries"
                    description-connector="of"
                    description-body="Pages"
                    class="table-height"
                  >
                    <template slot="header">
                      <div class="list-heading">
                        {{ $t("billManagement.label.BillHistory") }}
                      </div>
                      <!-- <ul class="horizontal-sm-btn flex mb-2 order-1">
                        <li>
                          <div
                            class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                          >
                            <datepicker
                              name="start-date"
                              :placeholder="$t('customers.label.start_date')"
                              v-model="search.fromDate"
                              :format="formattedStartDate"
                            ></datepicker>
                          </div>
                        </li>
                        <li>
                          <div
                            class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                          >
                            <datepicker
                              name="end-date"
                              class="end-date-calender"
                              :placeholder="$t('customers.label.end_date')"
                              v-model="search.toDate"
                              :format="formattedEndDate"
                            ></datepicker>
                          </div>
                        </li>
                        <li>
                          <div
                            class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                          >
                            <vs-button
                              color="primary"
                              type=""
                              icon-pack="feather"
                              class="mr-sm-3 mt-1"
                              @click="getBillHistoryList"
                            >
                              <feather-icon
                                icon="SearchIcon"
                                title="edit"
                                svgClasses="w-7 h-7 text-black stroke-current cursor"
                                @click.stop="editBill(bill.id)"
                                class="icon_row"
                              />
                            </vs-button>
                          </div>
                        </li>
                      </ul> -->
                    </template>
                    <template slot="thead">
                      <vs-th>{{ $t("billManagement.label.ExecutionDate") }}</vs-th>
                      <vs-th>{{ $t("billManagement.label.ExpectedNoOfCustomer") }}</vs-th>
                      <vs-th>{{ $t("billManagement.label.ActualBilledCustomer") }}</vs-th>
                      <!-- <vs-th>{{ $t("billManagement.label.TotalBillingAmount") }}</vs-th> -->
                      <vs-th>{{ $t("billManagement.label.ChargeJobRunId") }}</vs-th>
                      <!-- <vs-th class="tHeadCenter">{{
                        $t("billManagement.label.Action")
                      }}</vs-th> -->
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :key="index" :data="bill" v-for="(bill, index) in data">
                        <vs-td>{{ bill.executionDate }}</vs-td>
                        <vs-td>{{ bill.expectedNoofCustomer }}</vs-td>
                        <vs-td>{{ bill.actualBilliedCustomer }}</vs-td>
                        <!-- <vs-td>{{ bill.totalBillingAmount }}</vs-td> -->
                        <vs-td>{{ bill.chargesJobRunId }}</vs-td>
                        <!-- <vs-td class="whitespace-no-wrap">
                          <div class="container_img">
                            <div>
                              <vs-dropdown
                                vs-custom-content
                                vs-trigger-click
                                class="cursor-pointer"
                              >
                                <div class="con-img">
                                  <feather-icon
                                    title="More"
                                    icon="MoreHorizontalIcon"
                                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                    class="ml-2 icon_row"
                                  />
                                </div>

                                <vs-dropdown-menu class="vx-navbar-dropdown">
                                  <ul style="min-width: 13rem">
                                    <li
                                      class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                                    >
                                      <img
                                        class="logo-img"
                                        src="@/assets/images/icons/addplan.svg"
                                      />
                                      <span class="ml-2">{{
                                        $t("billManagement.label.DownloadReport")
                                      }}</span>
                                    </li>

                                    <li
                                      class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                                    >
                                      <img
                                        class="logo-img"
                                        src="@/assets/images/icons/addplan.svg"
                                      />
                                      <span class="ml-2">{{
                                        $t("billManagement.label.DownloadBillDetail")
                                      }}</span>
                                    </li>
                                  </ul>
                                </vs-dropdown-menu>
                              </vs-dropdown>
                            </div>
                          </div>
                        </vs-td> -->
                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </vs-tab>
              <vs-tab :label="$t('billManagement.label.TrialBillHistory')">
                <vx-card>
                  <vs-table
                    :max-items="paginationItems[1]"
                    pagination
                    :data="billHistoryList || []"
                    :description="false"
                    :description-items="paginationItems"
                    description-title="Registries"
                    description-connector="of"
                    description-body="Pages"
                    class="table-height"
                  >
                    <template slot="header">
                      <div class="list-heading">
                        {{ $t("billManagement.label.TrialBillHistory") }}
                      </div>
                      <!-- <ul class="horizontal-sm-btn flex mb-2 order-1">
                        <li>
                          <div
                            class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                          >
                            <datepicker
                              name="start-date"
                              :placeholder="$t('customers.label.start_date')"
                              v-model="search.fromDate"
                              :format="formattedStartDate"
                            ></datepicker>
                          </div>
                        </li>
                        <li>
                          <div
                            class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                          >
                            <datepicker
                              name="end-date"
                              class="end-date-calender"
                              :placeholder="$t('customers.label.end_date')"
                              v-model="search.toDate"
                              :format="formattedEndDate"
                            ></datepicker>
                          </div>
                        </li>
                        <li>
                          <div
                            class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                          >
                            <vs-button
                              color="primary"
                              type=""
                              icon-pack="feather"
                              class="mr-sm-3 mt-1"
                              @click="getBillHistoryList"
                            >
                              <feather-icon
                                icon="SearchIcon"
                                title="edit"
                                svgClasses="w-7 h-7 text-black stroke-current cursor"
                                @click.stop="editBill(bill.id)"
                                class="icon_row"
                              />
                            </vs-button>
                          </div>
                        </li>
                      </ul> -->
                    </template>
                    <template slot="thead">
                      <vs-th>{{ $t("billManagement.label.ExecutionDate") }}</vs-th>
                      <vs-th>{{ $t("billManagement.label.ExpectedNoOfCustomer") }}</vs-th>
                      <vs-th>{{ $t("billManagement.label.ActualBilledCustomer") }}</vs-th>
                      <!-- <vs-th>{{ $t("billManagement.label.TotalBillingAmount") }}</vs-th> -->
                      <vs-th>{{ $t("billManagement.label.ChargeJobRunId") }}</vs-th>
                      <!-- <vs-th class="tHeadCenter">{{
                        $t("billManagement.label.Action")
                      }}</vs-th> -->
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr :key="index" :data="bill" v-for="(bill, index) in data">
                        <vs-td>{{ bill.executionDate }}</vs-td>
                        <vs-td>{{ bill.expectedNoofCustomer }}</vs-td>
                        <vs-td>{{ bill.actualBilliedCustomer }}</vs-td>
                        <!-- <vs-td>{{ bill.totalBillingAmount }}</vs-td>
                       -->
                        <vs-td>{{ bill.chargesJobRunId }}</vs-td>
                        <!-- <vs-td class="whitespace-no-wrap">
                          <div class="container_img">
                            <div>
                              <vs-dropdown
                                vs-custom-content
                                vs-trigger-click
                                class="cursor-pointer"
                              >
                                <div class="con-img">
                                  <feather-icon
                                    title="More"
                                    icon="MoreHorizontalIcon"
                                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                    class="ml-2 icon_row"
                                  />
                                </div>

                                <vs-dropdown-menu class="vx-navbar-dropdown">
                                  <ul style="min-width: 13rem">
                                    <li
                                      class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                                    >
                                      <img
                                        class="logo-img"
                                        src="@/assets/images/icons/addplan.svg"
                                      />
                                      <span class="ml-2">{{
                                        $t("billManagement.label.DownloadReport")
                                      }}</span>
                                    </li>

                                    <li
                                      class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                                    >
                                      <img
                                        class="logo-img"
                                        src="@/assets/images/icons/addplan.svg"
                                      />
                                      <span class="ml-2">{{
                                        $t("billManagement.label.DownloadBillDetail")
                                      }}</span>
                                    </li>
                                  </ul>
                                </vs-dropdown-menu>
                              </vs-dropdown>
                            </div>
                          </div>
                        </vs-td> -->
                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  components: {
    Datepicker,
    AtomSpinner,
  },
  data() {
    return {
      loading: false,
      activeTab: 0,
      paginationItems: [5, 10, 15],
      search: {
        fromDate: moment().startOf("month").format("YYYY-MM-DD"),
        toDate: moment().endOf("month").format("YYYY-MM-DD"),
      },
    };
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      billHistoryList: (state) => state.billManagement.billHistoryList,
    }),
    formattedStartDate() {
      let dateStr = moment(this.search.fromDate).format(this.formattedDate);
      let [day, month, year] = dateStr.split("-");
      day = day.toLowerCase();
      year = year.toLowerCase();
      return `${day}-${month}-${year}`;
    },
    formattedEndDate() {
      let dateStr = moment(this.search.toDate).format(this.formattedDate);
      let [day, month, year] = dateStr.split("-");
      day = day.toLowerCase();
      year = year.toLowerCase();
      return `${day}-${month}-${year}`;
    },
  },
  methods: {
    getDate(date) {
      const timeFormat = "hh:mm a";
      const combinedFormat = `${this.formattedDate} ${timeFormat}`;
      return moment(date).format(combinedFormat);
    },
    async getBillCycleMethod() {
      try {
        await this.$store.dispatch("billManagement/getBillCycleAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getBillHistoryList() {
      try {
        // await this.$store.dispatch("customerActivityLog/getActivityLogList", {
        //   id: this.clientId,
        //   fromDate: moment(this.search.fromDate).format("YYYY-MM-DD"),
        //   toDate: moment(this.search.toDate).format("YYYY-MM-DD"),
        // });
        await this.$store.dispatch("billManagement/getBillHistoryAction");
      } catch (e) {
        console.log(
          "something went to wrong while retrieving transaction history office:",
          e
        );
      }
    },
  },

  async mounted() {
    this.loading = true;
    await this.getBillHistoryList();
    this.loading = false;
  },
};
</script>
<style>
.date-field .vdp-datepicker {
  margin-top: 2px;
}
.end-date-calender .vdp-datepicker__calendar {
  right: 0;
}
.table-height .vs-table--content {
  min-height: 47vh;
}
</style>
